import axios from "@/api/axiosInstance";
import {
  UpdateStagePermissionsRequest,
  UpdateStagePermissionsResponse,
} from "./types";

export const updateStagePermissions = async (
  uuid: string,
  requestData: UpdateStagePermissionsRequest,
): Promise<UpdateStagePermissionsResponse> => {
  const response = await axios.put<UpdateStagePermissionsResponse>(
    `/api/private/admin/stages/${uuid}/permissions`,
    requestData,
  );
  return response.data;
};
